import { ofType } from "redux-observable";
import { concat, EMPTY, from, of } from "rxjs";
import { switchMap, take } from "rxjs/operators";
import { IdDefaultThreshold } from "../../constants/IdDefaultThreshold";
import { selectOngoingPurchaseInfoPremium } from "../../selectors/selectOngoingPurchaseInfo";
import { actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { actionOngoingPurchasePremiumSelect } from "../ongoing-purchase/actionOngoingPurchase";
import { TypeActionSpendGoldConfirmation } from "../spend-gold-confirmation/actionSpendGoldConfirmation";
import { TypeActionBuyWithGold, } from "./actionBuyWithGold";
export var epicBuyWithGoldCheckConfirmationNeeded = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionBuyWithGold.CheckGoldConfirmationNeeded), switchMap(function (action) {
        var cost = action.requiredGold;
        if (cost.lessThan(IdDefaultThreshold.GoldSpendConfirmAmount)) {
            if (action.onProcessPreConfirm) {
                return from([action.onProcessPreConfirm, action.onProcessConfirmed]);
            }
            return of(action.onProcessConfirmed);
        }
        var premiumInfo = {
            goldAmount: cost,
            isConfirmed: false,
        };
        return concat(from([
            actionOngoingPurchasePremiumSelect(premiumInfo),
            actionModalOpen(IdModal.SpendGoldConfirmation),
        ]), action$.pipe(ofType(TypeActionSpendGoldConfirmation.Finish), take(1), switchMap(function () {
            var ongoingPurchaseInfo = selectOngoingPurchaseInfoPremium(state$.value);
            var isPurchaseConfirmed = ongoingPurchaseInfo && ongoingPurchaseInfo.isConfirmed;
            var conclusiveAction = isPurchaseConfirmed
                ? action.onProcessConfirmed
                : action.onProcessDenied;
            return conclusiveAction
                ? action.onProcessPreConfirm
                    ? from([action.onProcessPreConfirm, conclusiveAction])
                    : of(conclusiveAction)
                : EMPTY;
        })));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/buy-with-gold/epicBuyWithGoldCheckConfirmationNeeded.ts
// module id = 1792
// module chunks = 3